module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Contents#ack",
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "pn"
  }, [_vm._v("In acknowledging helpful influences on my work, I will always feel the need to mention two individuals whose personal investments in me have greatly shaped the course of my academic life. Richard Swinburne took me on as a DPhil student, a decision for which I will always be thankful. Working under his guidance was a cherished opportunity. And his writings continue to be resources to which I turn again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("Jerry Walls introduced me to the subject of philosophy of religion some twenty-five years ago. His ongoing support and encouragement have been enormous through the years. Without necessarily trying to do so, he has taught me many lessons about friendship and about how to nurture students. I do not see how I would possibly have become a philosopher if I had not crossed paths with Jerry.")]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("My parents, Ken and Hilda, probably imagined that their days of helping me improve my writing would have ended when I stopped bringing homework home from school. These many years later, they’re still helping; and I remain grateful to them for this, among other things.")]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("My wife, Barbara, has given me a variety of insights into what is good—the kinds of insights possible only when one is around another person every day. I’ve now written a book about goodness; she continues to live it out.")]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("Our son, Joseph, has been a most welcome presence during the latter stages of this project. Joseph, you’ve given me examples of the joys that come within relationships of benevolence, just as I was trying to write on the subject. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("To our daughter, Anna Keren, you’ve more than lived up to the promise we believe we were given that you would be, in a word, good. Most of the early ideas for this book were formed as we took daily walks around University Parks. This book is dedicated to you.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96f2e200","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgement.vue
// module id = 78
// module chunks = 0